var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title,"closable":true,"close-enabled":!_vm.isSubmitting,"buttons":_vm.buttons},on:{"close":_vm.close}},[_c('p',[_vm._v(_vm._s(_vm.messageText))])])}
var staticRenderFns = []

export { render, staticRenderFns }